import {Box,Table,Thead,Tbody,Tr,Th,Td,TableContainer, Badge, Text, IconButton,Menu,MenuButton,MenuList, MenuItem,Avatar,Tooltip, Center, Spacer} from '@chakra-ui/react'
import {  EditIcon, HamburgerIcon, ViewIcon,CheckIcon,MinusIcon } from '@chakra-ui/icons';
import {useState } from 'react'
import {  colorSchmemes, loggedOper as lp, userCanEdit } from '../../util/grunt';
import GruntPager from '../custom/GruntPager';

export default function OdlasciTable({odlasci,onEditOdlazak,onViewOdlazak,onViewDolazak,izlucenje=false,readonly=false, onVerificiraj,tableSize='xs'}) {
    const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",rowsperpage:20,currpage:1});
    

    const ShowGruntPager=()=>{
        if (odlasci.length>0) {
            return (
                <GruntPager currpage={prikaz.currpage} rowcount={odlasci.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                );    
        }
        
    }

    const migracijaEdit=(migracijaid,migracijatipsifra)=>{
        onEditOdlazak(migracijaid,migracijatipsifra);
    }

    const onVerificirajClick=(migracijaid,verificiran=true)=>{
        onVerificiraj(migracijaid,verificiran);
    }

    const migracijaView=(migracijaid,migracijatipsifra)=>{
        onViewOdlazak(migracijaid,migracijatipsifra);
    }

    const onClickDolaznaMigracija = (migracijaid)=>{
        onViewDolazak(migracijaid);
    }
    const showOdlasci=()=>{
        if (!izlucenje) {
            return (
                <>
                    <TableContainer overflowY={'auto'} h={'75vh'}>
                        <Table variant={'unstyled'} size={tableSize}>
                            <Thead _hover={{cursor:'pointer'}} fontSize={tableSize}>
                                <Tr>
                                    <Th w={'2%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                                    <Th w={'1%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spec.</Th>
                                    <Th w={'18%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Knjiga</Th>
                                    <Th w={'12%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Tip</Th>
                                    <Th w={'3%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Novi posjednik/klaonica</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Nova knjiga</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>IJR</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Dokument</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Broj grla</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Unio</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                            {odlasci.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                                 return (
                                    <Tr  color={'grunt2'} key={item.migracija_id}  bg={'white'} fontWeight={'normal'} 
                                    _hover={{bg:'gray.100'}} h='2rem'>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                        <Menu>
                                            <MenuButton
                                                as={IconButton}
                                                aria-label='Options'
                                                icon={<HamburgerIcon />}
                                                variant={'outline'} size={'xs'}
                                                isDisabled={readonly}
                                            />
                                            <MenuList>
                                                
                                                <MenuItem icon={<ViewIcon boxSize={'14px'} />} onClick={()=>migracijaView(item.migracija_id,item.migracija_tip_sifra)}>
                                                    Pregled
                                                </MenuItem>
                                                <MenuItem isDisabled={readonly || item.izlucenje} icon={<EditIcon boxSize={'14px'} />} onClick={(mid,tip)=>migracijaEdit(item.migracija_id,item.migracija_tip_sifra)}>
                                                    Uredi podatke
                                                </MenuItem>
                                                {item.dolazna_migracija_id>0?
                                                    <MenuItem icon={<ViewIcon boxSize={'14px'} />} onClick={(id)=>onClickDolaznaMigracija(item.dolazna_migracija_id)}>
                                                        Dolazna migracija
                                                    </MenuItem>
                                                    :<></>}
                                            </MenuList>
                                        </Menu>
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>{item.specifikacija_id!==0?<Badge colorScheme='green' variant={'solid'}>{item.specifikacija_id}</Badge>:null}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>{item.knjiga}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                                <Badge size={'xs'} fontWeight={'normal'} variant={'solid'} colorScheme={colorSchmemes[(item.migracija_tip.charCodeAt(0))%16]}>{item.migracija_tip}</Badge>
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                                {item.doldrzavacode!=="HR"?<Badge size={'xs'} fontWeight={'normal'} variant={'solid'} colorScheme={colorSchmemes[(item.doldrzavacode.charCodeAt(0))%16]}>{item.doldrzavacode}</Badge>:<>--</>}
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                            {item.novi_posjednik?item.jibg===''?item.dolposjednik:`${item.dolposjednik} (${item.jibg})`:'--'}
                                            
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{item.dolknjiga || '--'}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{new Date(item.datum).toLocaleDateString('hr-HR')}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{new Date(item.ijr).toLocaleDateString('hr-HR')}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{item.dokument_broj}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{readonly?"--":item.br_grla}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                            <Tooltip label={item.unio} fontSize={'xs'} placement={'left-start'}>
                                                <Avatar bg={'grunt2.100'} size={'xs'} name={item.unio}/>
                                            </Tooltip>
                                        </Td>
                                    </Tr>
                                 )
                            })}
                            </Tbody>
                            </Table>
                    </TableContainer>
                    
            </>
            )    
        } else {//izlučenje
            return (
                <>
                    <TableContainer overflowY={'auto'} h={'75vh'} className='noscroll' mb={'1rem'}>
                        <Table variant={'unstyled'} size='sm'>
                            <Thead _hover={{cursor:'pointer'}}>
                                <Tr>
                                    <Th w={'2%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}></Th>
                                    <Th w={'18%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Knjiga</Th>
                                    <Th w={'18%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Tip</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Datum</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Isporučeno u JR</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Dokument</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Broj grla</Th>
                                    <Th w={'10%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Unio</Th>
                                    
                                </Tr>
                            </Thead>
                            <Tbody>
                            {odlasci.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage).map((item,i)=>{
                                 return (
                                    <Tr  color={'grunt2'} key={item.migracija_id}  bg={'white'} fontWeight={'normal'} 
                                    _hover={{bg:'gray.100'}} h='2rem' >
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                        <Menu>
                                            <MenuButton
                                                as={IconButton}
                                                aria-label='Options'
                                                icon={<HamburgerIcon />}
                                                variant={'outline'} size={'xs'}
                                            />
                                            <MenuList>
                                                
                                                <MenuItem icon={<ViewIcon />} onClick={()=>migracijaView(item.migracija_id,item.migracija_tip_sifra)}>
                                                    Pregled
                                                </MenuItem>
                                                {item.verificiran?
                                                    <MenuItem isDisabled={!userCanEdit()} icon={<MinusIcon boxSize={'14px'}/>} onClick={()=>{onVerificirajClick(item.migracija_id,false)}}>
                                                        Ukini verifikaciju
                                                    </MenuItem>:
                                                    <MenuItem isDisabled={lp.uloga!=="v"} icon={<EditIcon boxSize={'14px'}/>} onClick={(mid,tip)=>migracijaEdit(item.migracija_id,item.migracija_tip_sifra)}>
                                                        Uredi podatke
                                                    </MenuItem>
                                                }
                                                {item.verificiran?<></>:
                                                    <MenuItem isDisabled={!userCanEdit()} icon={<CheckIcon boxSize={'14px'}/>} onClick={()=>{onVerificirajClick(item.migracija_id,true)}}>
                                                        Verificiraj
                                                    </MenuItem>
                                                }
                                            </MenuList>
                                        </Menu>
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'} fontWeight={'normal'}>{item.knjiga}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                                <Badge size={'xs'} fontWeight={'normal'} variant={'solid'} colorScheme={colorSchmemes[(item.migracija_tip.charCodeAt(0))%16]}>{item.migracija_tip}</Badge>
                                        </Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{new Date(item.datum).toLocaleDateString('hr-HR')}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{new Date(item.ijr).toLocaleDateString('hr-HR')}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{item.dokument_broj}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>{item.br_grla}</Td>
                                        <Td fontSize={tableSize} textAlign={'center'}>
                                            <Tooltip label={item.unio} fontSize={'xs'} placement={'left-start'}>
                                                <Avatar color={'black'} size={'xs'} bg={'grunt2.100'} name={item.unio}/>
                                            </Tooltip>
                                        </Td>
                                    </Tr>
                                 )
                            })}
                            </Tbody>
                            </Table>
                    </TableContainer>
                    
            </>
            ) 
        }
        
    }
    const getFooter=()=>{
        return (
            
            <Box flexDir={'row'} display={'flex'} w="100%" alignItems={'center'}>
                
                <Box w="25%">
                    {showBrZapis()}
                </Box>
                <Box w="50%">
                    <Center>
                        {ShowGruntPager()}
                    </Center>
                </Box>
                <Box w="25%">
                    
                </Box>
            </Box>
            
        )
      }
      const showBrZapis=()=>{
        return (
          <Text fontSize={'xs'}>Prikazano zapisa: {odlasci.length}</Text>
        )
      }
    
  return (
    <Box display={'flex'} flexDir={'column'} flex={1} pb={'0.2rem'}>
        {showOdlasci()}
        <Spacer/>
        {getFooter()}
    </Box>
  )
}
